<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: 10%;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td style="padding-left: 15px; padding-top: 10px; vertical-align: top;">
            <p style="margin-top: 0;margin-bottom: 0; text-align: left; line-height: 1;"><span style="white-space: pre; font-size: 10pt;">{{ getCompanySetting('CompanySettings', 'CompanyAddress')}}</span></p>
          </td>
          <td>&nbsp;</td>
          <td style="min-width: 35%; max-width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Order Num</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordernum }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Order Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.salesorderdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
              <tr v-if="initvalue.salesorderduedate!=null">
                <td><span style="font-size: 11pt; font-weight: bold">Due Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt; text-align: right;">{{ new Date(initvalue.salesorderduedate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%">
        <tr>
          <td><div style="text-align: center;"><h4 class="ma-0"><b>{{ initvalue.salesordertype }}</b></h4></div></td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%;">
        <tr>
          <td style="width:45%; padding-left: 15px;">
            <div style=" text-align: start; margin: 0;">
              <span style="font-size: 11pt; font-weight: bold; text-align: start;">Customer</span>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesordername }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesorderaddress }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesorderphone }}</p>
              <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.salesordermobile }}</p>
            </div>          
          </td>
          <td>&nbsp;</td>
          <td style="width: 45%; vertical-align: text-top; align-items: end;">
            <table style="width: 100%;">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold;">Order Type</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertype }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Pay Method</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_paymethod_name }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_location }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Sales Rep</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ data_user }}</span></td>
              </tr>

            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 7px; padding-bottom: 7px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th :style="css['row-top-left']" width="2%">#</th>
            <th :style="css['row-top-left']">Item</th>
            <th :style="css['row-top-left']" width="7%"></th>
            <th :style="css['row-top-left']" width="10%">Qty</th>
            <th :style="css['row-top-left']" width="10%">Prc</th>
            <th :style="css['row-top-right']" width="15%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
            <td :style="css['row-left-mr']">{{ index + 1 }}</td>
            <td :style="css['row-left-mr']">{{ trans.itemname }}</td>
            <td :style="css['row-left-mr']">{{ trans.itemfoc }}</td>
            <td :style="css['row-left-mr']">{{ formatQuantity(trans) }}</td>
            <td :style="css['row-left-mr']">{{ formatPrice(trans) }}</td>
            <td :style="css['row-right-ml']">{{ formatAmount(trans) }}</td>
          </tr>
          <tr><td colspan="6" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
          <tr>
            <td colspan="6" style="vertical-align: text-top; ">
              <table width="100%">
                <tr>
                  <td style="max-width: 180px; vertical-align: top;">
                    <table width="100%">
                      <tr>
                        <td>
                          <p style="margin-bottom: 20px;"><strong>Note:</strong></p> <span style="white-space: pre">{{ initvalue.salesordernote }}</span>
                        </td>
                      </tr>
                      <tr v-if="data_paymethod!=null">
                        <td v-if="data_paymethod.paymethodtype=='Qr Code'" colspan="5"><p style="margin:0"><strong>{{ data_paymethod.paymethodcode }}</strong></p> <span style="white-space: pre"></span>
                          <div>
                            <img :src="data_paymethod.qrcodeimage" contain width="175">
                          </div>
                          <p style="margin:0"><strong>{{ data_paymethod.paymethodinfo }}</strong></p>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td width="45%" style="align-content: start;">
                    <table v-if="initvalue.salesordertotal!=null" width="100%">
                      <tr>
                        <td><span style="font-size: 11pt; font-weight: bold">Tax ({{ (parseFloat(getCompanySetting('TaxSettings', 'TaxRate'))*100) + '%' }}):</span></td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordertaxamount).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertaxamount.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                      <tr>
                        <td><span style="font-size: 11pt; font-weight: bold">Subtotal: </span></td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordersubtotal).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordersubtotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                      <tr>
                        <td><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                        <td v-if="initvalue.primaryCurrency!=initvalue.secondaryCurrency" style="text-align: right"><span style="font-size: 11pt;">{{ convertCurrency(initvalue.salesordertotal).toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.secondaryCurrency }}</span></td>
                        <td v-else style="text-align: right"><span></span></td>
                        <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.salesordertotal.toFixed(2) }} </span><span style="font-size: 9pt;">{{ initvalue.primaryCurrency }}</span></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr><td colspan="6">&nbsp;</td></tr>

        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../util/tools';

export default {
  name: 'PrintSalesOrder',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      data_company: {},
      css: {
        'row-top-right': 'text-align: right; border-bottom: 1px; border-bottom-style: solid',
        'row-top-left': 'text-align: left; border-bottom: 1px; border-bottom-style: solid',
        'row-left-mr': 'vertical-align: top; text-align: left; padding-right: 5px;',
        'row-right-ml': 'vertical-align: top; text-align: right; padding-left: 5px;',
        'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
        'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
      },
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getSalesOrderRequest', 'getCompanyDataRequest']),
    getCompanySetting(code, name){
      if(this.data_company.settings==null || this.data_company.settings.length==0) return '';
      let results = this.data_company.settings.find(setting=>setting.settingcode==code);
      let result = results.settinglists.find(result=>result.settingname==name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    
    data_account(id){
      if(this.data_company.accounts==null || this.data_company.accounts.length==0) return null;
      let account = this.data_company.accounts.find(i=>i._id == id);
      if(account!=null) return account['accountcode'];
      return '';
    },
    data_item(id){
      if(this.data_company.items==null || this.data_company.items.length==0) return null;
      let item = this.data_company.items.find(i=>i._id == id);
      if(item!=null) return item['itemname'];
      return '';
    },
    convertCurrency(amount){
      let rate = parseFloat(this.initvalue.currencyRate);
      if(rate==null) rate = 0;
      return amount * rate;
    },
    formatQuantity(trans){
      let result;
      if(trans==null || trans.itemquantity==null) return 0;
      if(trans.itemfoc=='Foc' || trans.itemfoc=='Promot') result = trans.itemquantity.toFixed(3);
      else {
        if(trans.itemquantity<1) result = trans.itemquantity.toFixed(1);
        return result = trans.itemquantity.toFixed(0);
      }
      return result;
    },
    formatPrice(trans){
      let result;
      if(trans==null || trans.itemprice==null) return 0;
      else result = trans.itemprice.toFixed(2);
      return result;
    },
    formatAmount(trans){
      let result;
      if(trans==null || trans.itemamount==null) return 0;
      else result = trans.itemamount.toFixed(2);
      return result;
    },
  },
  computed: {
    data_location(){
      if(this.data_company.locations==null || this.data_company.locations.length==0) return null;
      let location = this.data_company.locations.find(i=>i._id == this.initvalue.locationid);
      if(location!=null) return location['locationname'];
      return '';
    },
    data_user(){
      if(this.data_company.users==null || this.data_company.users.length==0) return null;
      let user = this.data_company.users.find(i=>i._id == this.initvalue.userid);
      if(user!=null) return user['username'];
      return '';
    },
    data_paymethod(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod;
      return null;
    },
    data_paymethod_name(){
      if(this.data_company.paymethods==null || this.data_company.paymethods.length==0) return null;
      let paymethod = this.data_company.paymethods.find(i=>i._id == this.initvalue.paymethodid);
      if(paymethod!=null) return paymethod['paymethodname'];
      return null;
    }
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getSalesOrderRequest(this.id);
      if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
    }
  },
}

</script>

<style src="./Print.scss" lang="scss"/>
